module.exports = __webpack_public_path__ + "img/blackList.26c1ff47.jpg";